<fhm-search-page [gridData]="gridData" [showLink]="true" [showAdd]="true" [type]="'customer-instance-group-search'"
                 [columns]="['groupId']"
                 (addNew)="addNew()" [showDelete]="false" (selectRecord)="recordSelected($event)">
</fhm-search-page>
